export function wave_steps({compId,shapeHeight,animationSpeed,flipAnimation}) {
  return `
  <pattern class="patternRepeat" id="pat_${compId}" style="transform: translate(${-shapeHeight*3.5}px,0)" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#bbbbbb" points="160,200 0,240 0,480 160,440 	"/>
    <polygon fill="#888888" points="-320,240 -160,200 160,200 0,240 	"/>
    <rect x="-320" y="240" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -200;0 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#bbbbbb" points="160,200 0,240 0,480 160,440 	"/>
    <polygon fill="#888888" points="-320,240 -160,200 160,200 0,240 	"/>
    <rect x="-320" y="240" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="320 0;320 -200;320 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#bbbbbb" points="160,200 0,240 0,480 160,440 	"/>
    <polygon fill="#888888" points="-320,240 -160,200 160,200 0,240 	"/>
    <rect x="-320" y="240" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="640 0;640 -200;640 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#bbbbbb" points="160,200 0,240 0,480 160,440 	"/>
    <polygon fill="#888888" points="-320,240 -160,200 160,200 0,240 	"/>
    <rect x="-320" y="240" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 0;960 -200;960 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
      <polygon fill="#bbbbbb" points="160,200 0,240 0,480 160,440 	"/>
      <polygon fill="#888888" points="-320,240 -160,200 160,200 0,240 	"/>
      <rect x="-320" y="240" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1280 0;1280 -200;1280 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-4 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#bbbbbb" points="160,200 0,240 0,480 160,440 	"/>
    <polygon fill="#888888" points="-320,240 -160,200 160,200 0,240 	"/>
    <rect x="-320" y="240" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1600 0;1600 -200;1600 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#bbbbbb" points="160,200 0,240 0,480 160,440 	"/>
    <polygon fill="#888888" points="-320,240 -160,200 160,200 0,240 	"/>
    <rect x="-320" y="240" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1920 0;1920 -200;1920 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
  </pattern>
  <pattern class="patternRepeat" id="pat_2_${compId}" style="transform: translate(${-shapeHeight*3.5}px,0)" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">
  <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
  <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
  <rect x="-242" y="200" width="322" height="240"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="2240 -200;2240 0;2240 -200"
    keyTimes="0;0.5;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-5 * animationSpeed}s"
    dur="${6 * animationSpeed}s" repeatCount="indefinite" />
  </g>
  <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
  <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
  <rect x="-242" y="200" width="322" height="240"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="1920 -200;1920 0;1920 -200"
    keyTimes="0;0.5;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0 * animationSpeed}s"
    dur="${6 * animationSpeed}s" repeatCount="indefinite" />
  </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
    <rect x="-242" y="200" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1600 -200;1600 0;1600 -200"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
    <rect x="-242" y="200" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="1280 -200;1280 0;1280 -200"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
    <rect x="-242" y="200" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="960 -200;960 0;960 -200"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-3 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
    <rect x="-242" y="200" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="640 -200;640 0;640 -200"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-4 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
    <rect x="-242" y="200" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="320 -200;320 0;320 -200"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
    <g><polygon fill="#ffffff" points="-320,240 -160,200 160,200 160,480 -320,480 	"/>
    <polygon fill="#aaaaaa" points="-400,480 -240,440 -240,200 -400,240 	"/>
    <rect x="-242" y="200" width="322" height="240"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 -200;0 0;0 -200"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </g>
  </pattern>
  <mask id="mask_2_${compId}">
    <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_2_${compId})"></rect>
  </mask>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}